import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=c2c9b5d0&scoped=true&"
import script from "./authentication.vue?vue&type=script&lang=js&"
export * from "./authentication.vue?vue&type=script&lang=js&"
import style0 from "./authentication.vue?vue&type=style&index=0&id=c2c9b5d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c9b5d0",
  null
  
)

export default component.exports